module.exports = __webpack_public_path__ + "static/media/CatTongue.603db5f4.svg";